<template>
  <header :class="{'ems': $store.state.user.job === 'EMS', 'pemerintah': $store.state.user.job === 'Pemerintah'}">
    <div class="header__container">
      <div class="title__container">
        <img :src="$store.state.user.job === 'Pemerintah' ? '/img/pemerintah-logo.png' : '/img/ems-logo.png'" alt="pemerintah logo" />
        <div class="flex__title">
          <h1>Indopride {{$store.state.user.job === 'Pemerintah' ? 'Pemerintah' : 'EMS'}}</h1>
          <p>Mobile Database Terminal</p>
        </div>
      </div>
      <p style="margin: 0" v-if="$store.state.user.roleId >= 13 && $store.state.user.job === 'EMS'"><span class="name__button" @click="showKomaHandler()">Cek Total Mingguan Koma</span></p>
      <div class="name__container">
        <p>Welcome,&nbsp;&nbsp;{{fullName}} <span @click="clickHandler()" class="name__button">Logout</span></p>
      </div>
    </div>
  </header>
  <Transition name="fade">
    <div class="overlay-koma" v-if="showTotalKoma">
      <div class="koma__container">
        <div class="form__control">
          <h3>History Koma</h3>
          <span class="close--button" @click="closeHandler('history')">X</span>
        </div>
        <div class="option__container">
          <label class="option__label">Pilih mode per minggu: </label>
          <select class="option__select" v-model="weeklyKomaOption">
            <option value="3">3 kali</option>
            <option value="4">4 kali</option>
            <option value="5">5 kali</option>
            <option value="6">6 kali</option>
            <option value="7">7+ kali</option>
          </select>
        </div>
        <div class="grid">
          <div class="cell cell--header">Nama</div>
        </div>
        <div class="grid" v-for="(player, i) in totalKomaArr" :key="i">
          <div class="cell" v-if="player.counter === parseInt(7) ? player.counter >= parseInt(weeklyKomaOption) : player.counter === parseInt(weeklyKomaOption)">{{player.name}}</div>
        </div>
      </div>
    </div>
  </Transition>
</template>

<script>
  import jwt_decode from 'jwt-decode';
  import SearchController from '../Controller/SearchController.vue';
  export default {
    extends: SearchController,
    data() {
      return {
        timestamp: '',
        showTotalKoma: false,
        totalKomaArr: [],
        weeklyKomaOption: '3'
      }
    },
    computed: {
      fullName() {
        return this.$store.getters['user/getFullName']
      },
      getJakartaDate() {
        const jakartaDate = new Date(new Date().toLocaleString("en-US", {timeZone: "Asia/Jakarta"}));
        return jakartaDate.getDate() + '/' + (jakartaDate.getMonth() + 1) + '/' + jakartaDate.getFullYear(); 
      }
    },
    created() {
      if(localStorage.getItem('_rToken') !== undefined) {
        const decoded = jwt_decode(localStorage.getItem('_rToken'));
        this.$store.dispatch('user/setUser', {
          firstName: decoded.firstName,
          lastName: decoded.lastName,
          role: 0,
          id: decoded.id,
          job: decoded.job,
          roleId: decoded.roleId
        }, { root: true })
      }
      this.getNow();
      setInterval(() => {
        this.getNow()
      }, 1000);
    },
    methods: {
      clickHandler() {
        localStorage.removeItem('_rToken')
        document.cookie = 'accessToken=; Max-Age=-99999999'
        this.$router.push('/');
      },
      getNow() {
        const date = new Date((new Date).toLocaleString("en-US", {
            timeZone: "Asia/Jakarta"
        }));
        let hours = '';
        let minutes = '';
        let seconds = '';
        hours = date.getHours().toString().length === 1 ? '0' + date.getHours() : date.getHours().toString();
        minutes = date.getMinutes().toString().length === 1 ? '0' + date.getMinutes() : date.getMinutes().toString();
        seconds = date.getSeconds().toString().length === 1 ? '0' + date.getSeconds() : date.getSeconds().toString();
        const fulldate = hours + ':' + minutes + ':' + seconds
        this.timestamp = fulldate
      },
      closeHandler() {
        this.showTotalKoma = false;
        
      },
      showKomaHandler() {
        this.totalKomaArr = [];
        this.getWeeklyKoma()
          .then(result => {
            this.showTotalKoma = true;
            for(let i = 0; i < result.length; i++) {
              const index = this.totalKomaArr.findIndex(el => el.name === result[i].name)
              if(index !== -1) {
                this.totalKomaArr[index].counter++;
              } else {
                this.totalKomaArr.push({name: result[i].name, counter: 1})
              }
            }
          })
      }
    },
  }
</script>

<style scoped>
  header {
    display: flex;
    height: 20vh;
    width: 95%;
    align-items: center;
  }
  .header__container {
    width: 97%;
    height: 70px;
    border-radius: 0 50px 50px 0;
    border: solid 5px #D6B200;
    border-left: none;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  .pemerintah .header__container {
    background: #003D19;
  }
  .ems .header__container {
    background: rgb(90, 1, 1);
  }
  img {
    width: 150px;
    margin-right: 20px;
    margin-left: 20px;

  }

  .title__container {
    margin-left: 20px;
    display: flex;
    align-items: center;
  }
  h1 {
    font-size: 1.5em;
  }
  p {
    margin-top: 10px;
  }
  .time__container {
    text-align: center;
    height: 85%;
    border-radius: 10px;
  }

  .pemerintah .time__container {
    background: #388b51;
  }

  .ems .time__container {
    background: rgb(141, 2, 2);
  }

  .time__container p {
    font-size: 1.2em;
    margin: 5px 20px;
  }

  .name__container {
    margin-right: 40px;
  }

  .name__container p {
    font-size: 1.6em;
    margin-top: 0;
  }

  .name__button {
    background: red;
    padding: 10px 20px;
    font-size: 17px;
    display: inline-block;
    border-radius: 5px;
    margin-left: 10px;
    vertical-align: middle;
    cursor: pointer;
    margin-bottom: 2px;
    margin: 0 0 0 10px;
  }
  .overlay {
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    position: absolute;
    z-index: 5;
}

.overlay__inner {
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    position: absolute;
}

.overlay__content {
    left: 50%;
    position: absolute;
    top: 50%;
    transform: translate(-50%, -50%);
}
.option__container {
  margin-bottom: 20px;
}
.option__select {
  margin-left: 20px;
  color: black;
  border: solid 1px black;
  padding: 0 20px;
  font-size: 20px;
  border-radius: 10px;
}
</style>